import React, { Component } from "react";
import { Link } from 'react-router-dom';
// connect is what allows us to connect a component to Redux's store
import { connect } from 'react-redux';
import { Container, Grid, Icon, Segment } from 'semantic-ui-react'
import { FormattedMessage } from 'react-intl';
import { isSuperAdmin } from '../utils/user-profile';
import Can from '../components/Can';
class Home extends Component {

    render() {
        //vars para verificar o que é mostrado consoante o utilizador, excepto super admin que ve tudo
        const companyProfile = this.props.user.profile.COMPANY + '-' + this.props.user.profile.PROFILE;
        const auxSAFlag = isSuperAdmin(this.props.user);

        return(
            <Container text style={{ paddingTop: '80px', paddingLeft: '20px' }}>
                <Grid columns={3} >
                    <Can do="viewIDsHidro" on={companyProfile}>
                        <Grid.Row>
                            <Can do="viewIDsHidroUNGE" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='tint'/>
                                        <Link to='/cent'>{auxSAFlag ? <FormattedMessage id="word.idHidroUNGE" /> : <FormattedMessage id="word.idHidro" />}</Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewIDsHidroPROD" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='tint'/>
                                        <Link to='/prod'>{auxSAFlag ? <FormattedMessage id="word.idHidroPROD" /> : <FormattedMessage id="word.idHidro" />}</Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewIDsHidroHist" on={companyProfile}>
                                <Grid.Column>         
                                    <Segment color='blue'>
                                        <Icon name='bar chart'/>
                                        <Link to='/hist'><FormattedMessage id="word.historicHidro" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                        </Grid.Row>
                    </Can>
                    <Can do="viewIDsTerm" on={companyProfile}>
                        <Grid.Row>
                            <Can do="viewIDsTermUNGE" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='thermometer half'/>
                                        <Link to='/instrTerm'>{auxSAFlag ? <FormattedMessage id="word.idTermUNGE" /> : <FormattedMessage id="word.idTerm" />}</Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewIDsTermPROD" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='thermometer half'/>
                                        <Link to='/prodTerm'>{auxSAFlag ? <FormattedMessage id="word.idTermPROD" /> : <FormattedMessage id="word.idTerm" />}</Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewIDsTermHist" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='bar chart'/>
                                        <Link to='/histTerm'><FormattedMessage id="word.historicTerm" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                        </Grid.Row>
                    </Can>
                    <Can do="viewIndisps" on={companyProfile}>
                        <Grid.Row>
                            <Can do="viewCIs" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='inbox'/>
                                        <Link to='/cis'><FormattedMessage id="word.indCom" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewFIs" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='envelope'/>
                                        <Link to='/fis'><FormattedMessage id="word.indRecord" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewIOs" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='announcement'/>
                                        <Link to='/ios'><FormattedMessage id="word.infoOco" /></Link>
                                    </Segment>
                                </Grid.Column>
                        </Can>
                        </Grid.Row>
                    </Can>
                    <Can do="viewConds" on={companyProfile}>
                        <Grid.Row>
                            <Can do="viewCCs" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='inbox'/>
                                        <Link to='/ccs'><FormattedMessage id="word.condCom" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewFCs" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='envelope'/>
                                        <Link to='/fcs'><FormattedMessage id="word.condRecord" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                        </Grid.Row> 
                    </Can>
                    <Can do="viewGeneralPTG" on={companyProfile}>
                        <Grid.Row>
                            <Can do="viewToDoPTG" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='black'>
                                        <Icon name='tasks'/>
                                        <Link to='/todoindispsconds'><FormattedMessage id="word.toDo" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewCurrentIndCondPTG" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='black'>
                                        <Icon name='world'/>
                                        <Link to='/allfs'><FormattedMessage id="word.allSheets" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewAlertsIndispsPTG" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='black'>
                                        <Icon name='warning sign'/>
                                        <Link to='/openfis'><FormattedMessage id="word.alertsIndisp" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                        </Grid.Row>
                    </Can>
                    <Can do="viewPlanesMantenimiento" on={companyProfile}>
                        <Grid.Row>
                            <Can do="viewCPs" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='inbox'/>
                                        <Link to='/cps'><FormattedMessage id="word.cPlaneamento" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewFPs" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='envelope'/>
                                        <Link to='/fps'><FormattedMessage id="word.fPlaneamento" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewPMs" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='file'/>
                                        <Link to='/pms'><FormattedMessage id="word.pMantenimiento" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                        </Grid.Row>
                    </Can>
                    <Can do="viewIndispsSujeto" on={companyProfile}>
                        <Grid.Row>
                            <Can do="viewISs" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='announcement'/>
                                        <Link to='/iss'><FormattedMessage id="word.iSujeto" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                        </Grid.Row>
                    </Can>
                    <Can do="viewGeneralESP" on={companyProfile}>
                        <Grid.Row>
                            <Can do="viewToDoESP" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='black'>
                                        <Icon name='tasks'/>
                                        <Link to='/todoplansindisps'><FormattedMessage id="word.toDoShort" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewCurrentIndCondESP" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='black'>
                                        <Icon name='world'/>
                                        <Link to='/allfs'><FormattedMessage id="word.allSheets" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                        </Grid.Row>
                    </Can>
                    <Can do="viewConfigs" on={companyProfile}>
                        <Grid.Row>
                            <Can do="viewUnits" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='industry'/>
                                        <Link to='/units'><FormattedMessage id="word.productionCentersProd" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewUsers" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='users'/>
                                        <Link to='/users'><FormattedMessage id="word.users" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                            <Can do="viewRules" on={companyProfile}>
                                <Grid.Column>
                                    <Segment color='blue'>
                                        <Icon name='list'/>
                                        <Link to='/rules'><FormattedMessage id="word.adminRules" /></Link>
                                    </Segment>
                                </Grid.Column>
                            </Can>
                        </Grid.Row>
                    </Can>
                </Grid>
            </Container>
        )
    }
}

// Let's map Redux's state and the dispatching of our action creator to props.
// We create a function that accepts state and then returns an object of props. 
const mapStateToProps = (state) => {
  return {
    user: state.loginStore.user 
  };
};

//export default Home;
export default connect(mapStateToProps, {})(Home);


// WEBPACK FOOTER //
// ./src/pages/home-page.js